import axios from 'axios'
import axiosConfig from './modules/axiosConfig'
import PageHome from './pages/Home.js'
import PageDsSections from './pages/ds_sections.js'
import PageLogin from './pages/Login'
import PageQuemSomos from './pages/pageQuemSomos'


import UseMouseOrKeyboard from './modules/UseMouseOrKeyboard'
import DesignSystem from './DesignSystem/DesignSystem'
import { register } from 'swiper/element/bundle'
import logs from './utils/logs'
import ripple from './modules/ripple'
import editorJS from "./modules/editorJS";
import formErros from './modules/formErros'
import depoimentos from './modules/depoimentos'
import certificacoes from './modules/certificacoes'
import etica from './modules/etica'
import formContato from './modules/formContato'
import abrirConta from './modules/abrirConta'
import rendaProdutos from './modules/rendaProdutos'
import formSejaNucleon from './modules/formSejaNucleon'
import instagramApi from './modules/instagramApi'
import swiperDepoSejaNucleon from './modules/swiperDepoSejaNucleon'
import swiperVagas from './modules/swiperVagas'
import swiperEmpresas from './modules/swiperEmpresas'
import formEmpresa from './modules/formEmpresa'
import formSugestao from './modules/formSugestao'
import formPrivacidade from './modules/formPrivacidade'
import menuHeader from './modules/menuHeader'
import localidadesHome from './modules/localidadesHome'
import produtosHome from './modules/produtosHome'
import formOuvidoria from './modules/formOuvidoria'
import faq from './modules/faq'
import swiperSingleUnidade from './modules/swiperSingleUnidade'
import mapaUnidades from './modules/mapaUnidades'
import swiperMorningCall from './modules/swiperMorningCall'
import swiperSobMedida from './modules/swiperSobMedida'
import videosBlog from './modules/videosBlog'
import animaAoScroll from './animation/animaAoScroll'
import animateSetup from './animation/animateSetup'
import pageBlog from './pages/pageBlog'
import pageColaboradores from './pages/pageColaboradores'
import DataAtual from './modules/dataAtual'



const pageHome = document.getElementById('Home')
const pageAbraSuaConta = document.getElementById('abra-sua-conta')

// import SvgUse from "./utils/SvgUse";

// Init
GLOBAL.DesignSystem = DesignSystem({})
register() // Swiper Web Component

// Config
axiosConfig({ csrf: GLOBAL.context?.csrf }, axios)
UseMouseOrKeyboard()
ripple()
formErros()
editorJS()
animateSetup()
animaAoScroll()
console.log('teste')

//Criadas
if (pageHome || pageAbraSuaConta){
    console.log(pageHome, pageAbraSuaConta);
    depoimentos();
}

certificacoes();
etica();
abrirConta();
//rendaProdutos();
swiperDepoSejaNucleon();
swiperVagas();
swiperEmpresas();
swiperSobMedida();
faq();
mapaUnidades();
DataAtual();
produtosHome();


//Blog
swiperMorningCall();
videosBlog();

//Forms
formOuvidoria();
formContato();
formEmpresa();
formSugestao();
formSejaNucleon();
formPrivacidade();

menuHeader();
localidadesHome();
swiperSingleUnidade();


// Pages
PageHome()
pageBlog()
PageQuemSomos()
pageColaboradores()

//PageDsSections()

PageLogin()?.init()

// utils logs
logs()

//Instagram
instagramApi()
